<template lang="pug" src="./custom-modal-text.pug"></template>

<script>
import Icon from 'components/icon/icon'

export default {
  props: ['props'],
  created () {
    console.log()
  },
  methods: {
    closeModal () {
      this.$store.dispatch('VIEW_SHOWMODAL', false)
    }
  },
  components: {
    Icon
  }
}
</script>



// WEBPACK FOOTER //
// custom-modal-text.vue?70a0f9c5